export const survey = {
    meta: {
        title: 'Ärzteumfrage',
        description: 'Helfen Sie uns, die Gesundheitsversorgung zu verbessern. Nehmen Sie an unserer Umfrage für Ärzte teil.',
    },
    page: {
        title: 'Ärzteumfrage',
        subtitle: 'Ihre Meinung zählt! Helfen Sie uns, TerminTeiler an die Bedürfnisse Ihrer Praxis anzupassen.',
    },
    participation: {
        label: 'Wie möchten Sie teilnehmen?',
        anonymous: 'Anonym',
        withPracticeData: 'Mit Praxisdaten (für Rückfragen/Pilotprojekt)',
        practiceName: 'Praxisname',
        contactPerson: 'Ansprechpartner',
        contactPlaceholder: 'Name des Ansprechpartners',
    },
    questions: {
        q1: {
            label: '1. Welche Tätigkeiten nehmen im Praxisalltag besonders viel Zeit in Anspruch?',
            options: {
                phone_changes: 'Telefonische Terminänderungen',
                availability_inquiries: 'Rückfragen zu freien Terminen',
                short_notice_absences: 'Organisation kurzfristiger Ausfälle',
                documentation_changes: 'Dokumentation von Änderungen',
                other_tasks: 'Andere organisatorische Aufgaben',
            },
        },
        q2: {
            label: '2. Wie häufig kommt es vor, dass Termine kurzfristig frei werden?',
            options: {
                very_often: 'Sehr häufig',
                often: 'Häufig',
                sometimes: 'Gelegentlich',
                rarely: 'Selten',
            },
        },
        q3: {
            label: '3. Inwiefern würden digitale Lösungen helfen, kurzfristige Terminänderungen strukturierter zu handhaben?',
            options: {
                very_strong: 'Sehr stark',
                strong: 'Stark',
                somewhat: 'Etwas',
                hardly: 'Kaum',
            },
        },
        q4: {
            label: '4. Welche Aspekte wären für Sie persönlich eine Erleichterung?',
            options: {
                fewer_interruptions: 'Weniger Telefonunterbrechungen',
                clear_overview: 'Klare Übersicht über Terminstatus',
                fewer_spontaneous_coordination: 'Weniger spontane Abstimmungen',
                predictable_day: 'Planbarerer Tagesablauf',
                calmer_phases: 'Ruhigere Arbeitsphasen',
            },
        },
        q5: {
            label: '5. Wie hilfreich wären folgende Funktionen für Ihren Arbeitsalltag? (1 = wenig / 5 = sehr hilfreich)',
            subLabels: {
                a: 'a) Digitale Weitergabe freigewordener Termine',
                b: 'b) Automatisches Zeitfenster für Neubesetzung',
                c: 'c) Kurze digitale Nachricht an Patienten statt Telefonanruf',
                d: 'd) Klare Zweckangabe des Termins (z.B. "Akut", "Kontrolle")',
            },
            scale: {
                low: 'Wenig hilfreich',
                high: 'Sehr hilfreich',
            },
        },
        q6: {
            label: '6. Welche Form der Kommunikation wäre für Sie im Alltag angenehmer? (Mehrfachauswahl möglich)',
            options: {
                short_digital: 'Kurze digitale Mitteilung',
                structured_phone: 'Telefonisch aber strukturiert',
                combination: 'Kombination aus beidem',
            },
        },
        q7: {
            label: '7. Wie wichtig ist Ihnen, dass neue digitale Lösungen den Praxisalltag nicht komplizierter, sondern übersichtlicher machen?',
            options: {
                very_important: 'Sehr wichtig',
                important: 'Wichtig',
                rather_important: 'Eher wichtig',
                less_important: 'Weniger wichtig',
            },
        },
        q8: {
            label: '8. Unter welchen Voraussetzungen würden Sie ein digitales System als Unterstützung wahrnehmen?',
            options: {
                simple_usage: 'Einfache Bedienung',
                clear_responsibilities: 'Klare Zuständigkeiten',
                no_extra_effort: 'Kein Mehraufwand',
                transparent_processes: 'Transparente Abläufe',
            },
        },
        q9: {
            label: '9. Welche Auswirkungen haben nicht wahrgenommene Termine auf Ihre Praxis?',
            options: {
                revenue_loss: 'Umsatzverluste',
                room_idle: 'Leerlauf von Behandlungsräumen',
                staff_idle: 'Leerlauf von Personal',
                unproductive_slots: 'Unproduktive Zeitfenster',
                workflow_disruption: 'Störungen im Praxisablauf',
                other: 'Andere (bitte angeben)',
            },
            otherPlaceholder: 'Bitte erläutern...',
        },
        q10: {
            label: '10. Gibt es in Ihrer Praxis Termine, deren Ausfall wirtschaftlich besonders relevant ist?',
            options: {
                yes: 'Ja',
                partial: 'Teilweise',
                no: 'Nein',
            },
            followUp: {
                label: 'Falls ja, welche?',
                options: {
                    dental: 'Zahnärztliche Behandlungen',
                    specialist_first: 'Fachärztliche Ersttermine',
                    longer_treatments: 'Längere Behandlungszeiten',
                    equipment_expensive: 'Apparative Leistungen (MRT, CT etc.)',
                    private_services: 'Privatleistungen / IGeL',
                },
            },
        },
        q11: {
            label: '11. Wie stark schätzen Sie den wirtschaftlichen Schaden durch nicht wahrgenommene Termine ein?',
            options: {
                very_high: 'Sehr hoch',
                high: 'Hoch',
                medium: 'Mittel',
                low: 'Gering',
            },
        },
        q12: {
            label: '12. Welche Faktoren verstärken den wirtschaftlichen Nachteil bei No-Shows?',
            options: {
                fixed_costs: 'Laufende Fixkosten (Personal, Miete)',
                short_term_non_replacement: 'Kurzfristige Nicht-Neubesetzbarkeit',
                special_preparation: 'Spezielle Vorbereitung war nötig',
                limited_availability: 'Begrenzte Terminverfügbarkeit allgemein',
            },
        },
        q13: {
            label: '13. Wie relevant wäre das wirtschaftlich für Ihre Praxis? (wenn ein System wenige Ausfälle/Monat vermeidet)',
            options: {
                very_relevant: 'Sehr relevant',
                relevant: 'Relevant',
                barely_relevant: 'Kaum relevant',
            },
        },
        q14: {
            label: '14. Könnten Sie sich vorstellen, ein solches System in einer Pilotphase zu testen?',
            options: {
                yes: 'Ja',
                rather_yes: 'Eher ja',
                under_conditions: 'Unter bestimmten Voraussetzungen',
            },
        },
        q15: {
            label: '15. Welche monatliche Preiskategorie würden Sie akzeptabel finden?',
            options: {
                basis: 'Basis (99–149 €)',
                standard: 'Standard (149–249 €)',
                premium: 'Premium (249–399 €)',
                skip: 'Keine Angabe / Weiß nicht',
            },
        },
        q16: {
            label: '16. Ab welchem monatlichen Betrag würde sich der Einsatz wirtschaftlich nicht mehr lohnen?',
            placeholder: 'Betrag eingeben...',
        },
        q17: {
            label: '17. Kontakt (freiwillig)',
            description: 'Möchten Sie über die Ergebnisse informiert werden oder an der Pilotphase teilnehmen?',
            personPlaceholder: 'Ansprechpartner',
            detailsPlaceholder: 'Telefonnummer / E-Mail',
        },
    },
    submit: {
        button: 'Umfrage absenden',
        sending: 'Wird gesendet...',
        success: 'Vielen Dank für Ihre Teilnahme!',
        error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    },
    validation: {
        required: 'Dies ist ein Pflichtfeld.',
        selectOne: 'Bitte wählen Sie eine Option.',
        selectAtLeastOne: 'Bitte wählen Sie mindestens eine Option.',
        enterText: 'Bitte geben Sie einen Text ein.',
    },
};
